import { useState } from 'react'
import BidButton from '../../../../elements/BidButton/BidButton'
import BackButton from '@components/ItemPage/Layout/Header/BackButton'
import AuctionInfo from '@components/ItemPage/Layout/Header/AuctionInfo'

const Header = () => {
  const [showInfo, setShowInfo] = useState<boolean>(false)

  return (
    <div>
      <div className="md:hidden h-14 flex justify-between items-center border-b-4 mobile-padding">
        <BackButton />
        <BidButton
          label={
            <span className="flex justify-center items-center gap-1 tracking-tighter text-xs whitespace-nowrap">
              AUCTION INFO
            </span>
          }
          theme="blue-light"
          callBack={() => setShowInfo((prevState) => !prevState)}
        />
      </div>
      <AuctionInfo showMobileInfo={showInfo} setShowMobileInfo={setShowInfo} />
    </div>
  )
}

export default Header
